import { ModuleDefinition } from "typings/flexFramework/FlexComponent";

export const getNameFromModuleDefinition = (moduleDefinition: ModuleDefinition): string => {
  let name = "";
  if (moduleDefinition.fmType === "REGION") {
    name = "region";
  } else if (moduleDefinition.fmType === "TAB") {
    name = "tab";
  } else {
    name = moduleDefinition.name;
  }

  return name;
};
